module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-panel",
    class: _vm.panelType
  }, [_c('div', {
    staticClass: "card-panel-heading"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "fa-5x",
    class: _vm.icon
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v(_vm._s(_vm.num))]), _vm._v(" "), _c('div', {
    staticClass: "title-size"
  }, [_vm._v(_vm._s(_vm.title))])])], 1)], 1), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.viewDetail
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-panel-footer"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22163640"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/cardPanel.vue
// module id = 1384
// module chunks = 1